namespace Solovis.UI {

    export interface ControlRouteMapRouteDataConfig {
        route: string | ControlRoute,
        controlType: any
    }

    export interface ControlRouteMapRouteData {
        route: ControlRoute,
        controlType: any
    }    

    export class ControlRouteMap {

        public routes: ControlRouteMapRouteData[];

        constructor(
            options: {
                routes: ControlRouteMapRouteDataConfig[]
            }
        ) {
            var self = this;

            // We'll fixup route data at the end to be sure it conforms to ControlRouteMapRouteData.
            this.routes = options.routes ? ((options.routes as any) as ControlRouteMapRouteData[]) : [];

            if (!this.routes)
                this.routes = [];

            // Convert any string routes into ControlRoute objects.
            for (let routeData of this.routes) {            
                this._fixupRouteData(routeData);
            }
        }

        public _fixupRouteData(routeData: ControlRouteMapRouteDataConfig): void {
            // Convert any string routes into ControlRoute objects.
            if (typeof routeData.route == "string") {
                routeData.route = new Solovis.UI.ControlRoute({ route: routeData.route });
            }
        }

        public addRoute(routeData: ControlRouteMapRouteDataConfig): void {
            this._fixupRouteData(routeData);
            this.routes.push(routeData as ControlRouteMapRouteData);
        }

        /**
         * This will return route data (route, controlType) for matching route.
         * @param route
         */
        public matchRoute(route: Solovis.UI.ControlRoute | string): ControlRouteMapRouteData {        
            let controlRoute: Solovis.UI.ControlRoute;

            if (typeof route === "string")
                controlRoute = new Solovis.UI.ControlRoute({ route: route });
            else
                controlRoute = route;

            let routePartCount = controlRoute.getRoutePartCount();

            // We will return the first routeData that matches.
            for (let routeData of this.routes) {                
                let routeToMatch = routeData.route as Solovis.UI.ControlRoute;

                var routeToMatchPartCount = (routeToMatch as Solovis.UI.ControlRoute).getRoutePartCount();
                if (routeToMatchPartCount <= routePartCount) {
                    let matchFound = true;
                    for (let partCo = 0; partCo < routeToMatchPartCount; partCo++) {
                        if (routeToMatch.getRoutePart(partCo) != controlRoute.getRoutePart(partCo)) {
                            matchFound = false;
                            break;
                        }
                    }

                    if (matchFound) {
                        return routeData;
                    }
                }
            }

            return null;
        }
    }
    
}